import * as React from 'react';

import ContactSupportForm from '@app/components/Pages/ContactSupport/ContactSupportForm';
import '@app/scss/pages/contactSupport.scss';
import '@app/scss/pages/login.scss';

const ContactSupport: React.FC = () => {
	return <>
		<div className="enter-page portal-form-center">
			<div className="enter-page__form general-form">
				<div className="enter-page__container">
					<div className="site-headline text-center">
						<h1>Contact Us</h1>
					</div>
					<div className="support-form-container">
						<ContactSupportForm />
					</div>
				</div>
			</div>
		</div>
	</>;
};

export default ContactSupport;
